import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { Link } from 'react-router-dom';
import { acceptCookies, declineCookies } from '../store/slices/cookieAcceptanceSlice';
import { initializeAnalytics } from '../utils/analyticsManager';

const CookiePopup = ({ onAccept }) => {

    const dispatch = useDispatch();
    const { accepted } = useSelector((state) => state.cookieAcceptance);

    const handleAccept = () => {
        dispatch(acceptCookies());
        initializeAnalytics(true, true);
        onAccept();
    };

    const handleDecline = () => {
        dispatch(declineCookies());
        initializeAnalytics(false, false);
        onAccept();
    };

    if (accepted) {
        return null;
    }
    return (
        <div className="text-center sm:text-left fixed bottom-0 left-0 right-0 bg-custom-dark-blue px-5 py-4 shadow-lg z-50 flex flex-wrap sm:flex-nowrap gap-3 items-center justify-center">
            <p className="text-sm">
                We use cookies to enhance your experience. By continuing to visit this site you agree to our <Link to="/cookie-policy" className="underline">Cookie Policy</Link>.
            </p>
            <div className='flex gap-2'>
                <button onClick={handleDecline} className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors">
                    Decline
                </button>
                <button onClick={handleAccept} className="bg-custom-light-blue text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors">
                    Accept All
                </button>
            </div>
        </div>
    );
};

export default CookiePopup;
